import React, { useEffect, useState } from 'react';
import Lottie from 'react-lottie-player';
// Note: This animation is a placeholder. You need to provide your own Lottie .json file.
// You can download one from LottieFiles.com and put it in your src/assets folder.
// For example, if your file is named 'fireworks.json', uncomment the line below.
// import fireworksAnimation from '../assets/fireworks.json';

const LoadingAnimation = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  
  // Replace the placeholder with your actual Lottie animation data
  const lottieAnimationData = {
    "v": "5.7.4",
    "fr": 30,
    "ip": 0,
    "op": 60,
    "w": 200,
    "h": 200,
    "layers": [
      {
        "ty": 4,
        "ind": 1,
        "st": 0,
        "ip": 0,
        "op": 60,
        "ks": {
          "o": { "a": 0, "k": 100 },
          "s": { "a": 0, "k": [100, 100, 100] },
          "p": { "a": 0, "k": [100, 100, 0] },
          "a": { "a": 0, "k": [100, 100, 0] },
          "r": { "a": 0, "k": 0 }
        },
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ty": "rc",
                "d": 1,
                "s": { "a": 0, "k": [50, 50] },
                "p": { "a": 0, "k": [0, 0] },
                "r": { "a": 0, "k": 10 }
              },
              {
                "ty": "fl",
                "c": { "a": 0, "k": [1, 0, 0, 1] },
                "o": 100
              },
              {
                "ty": "tr",
                "p": { "a": 0, "k": [0, 0] },
                "a": { "a": 0, "k": [0, 0] },
                "s": { "a": 0, "k": [100, 100] },
                "r": { "a": 0, "k": 0 },
                "o": 100
              }
            ]
          }
        ]
      }
    ]
  };

  useEffect(() => {
    // Simulate loading time, replace with your actual data fetching logic
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 2000); // 2 seconds

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className={`transition-opacity duration-500 ${isLoaded ? 'opacity-0' : 'opacity-100'}`}>
        <Lottie
          loop
          animationData={lottieAnimationData} // Or fireworksAnimation if you use your own file
          play
          style={{ width: 200, height: 200 }}
        />
        <p className="mt-8 text-xl font-bold text-gray-700">Loading your fireworks...</p>
      </div>
    </div>
  );
};

export default LoadingAnimation;